'use client';
import { COMPACT_PREVIEW_CONTEXT_STYLE, COMPACT_PREVIEW_DELTA_PERCENT_STYLE, COMPACT_PREVIEW_HERO_STYLE, COMPACT_PREVIEW_TITLE_STYLE, COMPACT_PREVIEW_VALUE_ROW_STYLE, COMPACT_PREVIEW_VALUE_STYLE, buildCompactPreviewDeltaStyle, buildCompactPreviewSeriesLabelStyle, } from './xychart-compact-preview-styles';
import { formatDeltaPercent, formatDeltaValue, formatHeroNumber, type XYChartCompactPreviewModel, } from './xychart-compact-preview-model';
export interface XYChartCompactPreviewHeroOverlayProps {
    model: XYChartCompactPreviewModel;
}
export function XYChartCompactPreviewHeroOverlay({ model, }: XYChartCompactPreviewHeroOverlayProps) {
    return (
      <div data-el="Cmarkdownxychart/CompactPreviewHeroOverlay/Root" style={COMPACT_PREVIEW_HERO_STYLE}>
        <div style={COMPACT_PREVIEW_CONTEXT_STYLE}>
          {model.latestCategoryLabel}
          {model.title && (<span style={COMPACT_PREVIEW_TITLE_STYLE}>
              • {model.title}
            </span>)}
        </div>
        <div style={COMPACT_PREVIEW_VALUE_ROW_STYLE}>
          <div style={COMPACT_PREVIEW_VALUE_STYLE}>
            {formatHeroNumber(model.latestValue)}
          </div>
          <div style={buildCompactPreviewSeriesLabelStyle({ color: model.trend.color })}>
            {model.focusSeries.label}
          </div>
        </div>
        {model.delta !== 0 && (<div style={buildCompactPreviewDeltaStyle({ color: model.trend.color })}>
            <span>
              {`${model.trend.arrow} ${model.trend.sign}${formatDeltaValue(model.delta)}`}
            </span>
            <span style={COMPACT_PREVIEW_DELTA_PERCENT_STYLE}>
              ({formatDeltaPercent(model.deltaPercent)})
            </span>
          </div>)}
      </div>
    );
}
